import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKlacht = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Klacht_svg__a"
      width={22}
      height={30}
      x={9}
      y={5}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="m23.73 31.26-3.49 3.48-3.48-3.48H9v-26h22v26z"
      />
    </mask>
    <g mask="url(#Klacht_svg__a)">
      <path
        fill="#F18700"
        d="M19.4 38.21 7.15 31.14l7.07-12.25z"
      />
      <path
        fill="#F18700"
        d="m.08 43.38 7.07-12.24 12.25 7.07z"
      />
      <path
        fill="#F7A941"
        d="M14.22 18.89 7.15 31.14-5.1 24.07z"
      />
      <path
        fill="#F18700"
        d="M14.22 18.89 1.98 11.82 9.05-.43z"
      />
      <path
        fill="#F7A941"
        d="M9.05-.43 1.98 11.82l-12.25-7.07zM-5.1 24.07l7.08-12.25 12.24 7.07zM38.72 33.03l-12.25-7.07 7.07-12.25z"
      />
      <path
        fill="#F18700"
        d="m14.22 18.89 12.25 7.07-7.07 12.25z"
      />
      <path
        fill="#F7A941"
        d="m19.4 38.21 7.07-12.25 12.25 7.07z"
      />
      <path
        fill="#F18700"
        d="m33.54 13.71-7.07 12.25-12.25-7.07z"
      />
      <path
        fill="#F7A941"
        d="m38.72 33.03-7.07 12.25-12.25-7.07z"
      />
      <path
        fill="#F18700"
        d="m28.36-5.61 12.25 7.08-7.07 12.24zM9.05-.43l12.24 7.07-7.07 12.25z"
      />
      <path
        fill="#F7A941"
        d="M33.54 13.71 21.29 6.64l7.07-12.25z"
      />
      <path
        fill="#F18700"
        d="M28.36-5.61 21.29 6.64 9.05-.43zM14.22 18.89l7.07-12.25 12.25 7.07z"
      />
    </g>
    <path
      fill="#fff"
      d="M18 10.26h4l-.68 11H18.7zm2 17a2 2 0 0 1-1.42-.58 1.9 1.9 0 0 1-.58-1.4 2 2 0 1 1 4 0 1.9 1.9 0 0 1-.58 1.4 2 2 0 0 1-1.42.58"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKlacht);

export default ForwardRef;
